import { StandardPatcher } from '.';
import { AsmArch, AsmPatch, StdPatch } from '..';
import { BlockEncoder, BlockEncoderOptions, Instruction, FastFormatter } from '@geeki/iced-x86';

class AssembleConverter {
    private _bitness: number;

    constructor(arch: AsmArch) {
        this._bitness = 0;

        if (arch === 'x86-32') {
            this._bitness = 32;
        } else if (arch == 'x86-64') {
            this._bitness = 64;
        } else {
            throw new Error('unsupported arch ' + arch);
        }
    }

    convert(asm: Instruction[], offset: number): number[] {
        const encoder = new BlockEncoder(this._bitness, BlockEncoderOptions.None);
        asm.forEach(i => encoder.add(i));

        const result = Array.from(encoder.encode(BigInt(offset)));
        encoder.free();

        return result;
    }

    private static instanes = {} as Record<AsmArch, AssembleConverter>;
    static get(arch: AsmArch): AssembleConverter {
        let result = AssembleConverter.instanes[arch];
        if (result)
            return AssembleConverter.instanes[arch];

        result = new AssembleConverter(arch);
        AssembleConverter.instanes[arch] = result;
        return result;
    }
}

export class AssemblerPatcher extends StandardPatcher {
    constructor(options: AsmPatch, baseAddr: number) {
        const patchset: StdPatch = {
            type: undefined,
            name: options.name,
            tooltip: options.tooltip,
            danger: options.danger,
            patches: options.patches.map(v => {
                const converter = AssembleConverter.get(options.arch);

                const on = converter.convert(v.on, v.va);
                const off = converter.convert(v.off, v.va);
                
                if (on.length != off.length) {
                    const formatter = new FastFormatter();

                    const onAsm = v.on.reduce((pv, cv) => pv + '\t' + formatter.format(cv) + '\n', '');
                    const offAsm = v.off.reduce((pv, cv) => pv + '\t' + formatter.format(cv) + '\n', '');
                    
                    formatter.free();

                    let message = 'asm patch ' + options.name + ' on and off length mismatch. \n';
                    message += 'on length: ' + on.length + ', asm code: \n';
                    message += onAsm;

                    message += '\noff length: ' + off.length + ', asm code: \n';
                    message += offAsm;

                    throw new Error(message);
                }

                return {
                    offset: v.offset ?? v.va - baseAddr,
                    on, off,
                };
            })
        }

        super(patchset, baseAddr);
    }
}
